import { SamplingValidationResults } from "@features/builder/GraphValidation/SamplingValidationResults"
import { presamplingValidationAtom } from "@features/builder/graph/nodes/validation/presamplingValidationAtom"
import { useAtomValue } from "jotai"

export const SamplingErrors = () => {
  const validationResult = useAtomValue(presamplingValidationAtom)

  if (!validationResult) return null

  return <SamplingValidationResults result={validationResult} />
}
